import { PayloadAction } from "@reduxjs/toolkit"
import { ObjectsStateT } from "../../objects.slice"
import { AddAnimationT } from "./animationTypes"

export type AddAutoAnimationsT = {
    animations: AddAnimationT[]
}

/**
 * Batch action to add multiple animations at once.
 * Uses Immer direct mutation for efficiency.
 * Results in a single undo/redo history entry for the entire operation.
 */
export const addAutoAnimationsBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<AddAutoAnimationsT>
) => {
    action.payload.animations.forEach(({ animation, objectId }) => {
        state.value[objectId].animations[animation.id] = animation
    })
}
